import React from "react";
import { Link } from "react-router-dom";
import PolicyPage, { SupportEmail } from "./PolicyPage";

function Terms() {
  return (
    <PolicyPage title="Terms of Service">
      <p>
        <strong>Agreement and incorporated policies</strong>
        <br />
        These Terms govern use of the Tuddlepetgoods website and purchases made
        through it. The policies linked from our <Link to="/policies">Policy Center</Link>
        form part of these Terms where relevant. If you do not agree, do not use
        the site. Mandatory consumer rights remain unaffected.
      </p>
      <p>
        <strong>Eligibility</strong>
        <br />
        You must have legal capacity to enter a contract in your location or use
        the site with the involvement of a parent or legal guardian. You are
        responsible for providing accurate contact, billing, and delivery
        information and for activity you authorize.
      </p>
      <p>
        <strong>Acceptable use</strong>
        <br />
        You may not break the law; infringe intellectual-property, privacy, or
        other rights; submit harmful code; probe or bypass security; interfere
        with operation; scrape at unreasonable scale; use automated purchasing
        tools; impersonate another person; make fraudulent payment claims; or
        use the site to distribute unlawful or deceptive content.
      </p>
      <p>
        <strong>Product information</strong>
        <br />
        We aim to describe products accurately. Screen settings, lighting,
        natural materials, handmade work, and vintage condition can create
        variations. Measurements and weights may be approximate. The{" "}
        <Link to="/product-information">Product Information Policy</Link> explains
        images, materials, sizing, certificates, and disclosed variation.
      </p>
      <p>
        <strong>Orders and contract formation</strong>
        <br />
        Submitting an order is an offer to purchase. An automated receipt is not
        acceptance. We accept when we expressly confirm acceptance or dispatch
        the product. We may reject or cancel before acceptance for availability,
        price or description errors, failed verification, suspected fraud,
        delivery restrictions, rights concerns, or legal reasons. See the{" "}
        <Link to="/orders-cancellations">Orders &amp; Cancellations Policy</Link>.
      </p>
      <p>
        <strong>Prices and payment</strong>
        <br />
        You authorize the displayed order amount and agree to pay applicable
        delivery and checkout charges. The issuer may charge conversion or bank
        fees. Payment authorization can be subject to verification and does not
        guarantee acceptance. Review the <Link to="/payments">Payment &amp; Security Policy</Link>
        and <Link to="/promotions-pricing">Pricing &amp; Promotions Policy</Link>.
      </p>
      <p>
        <strong>Custom and made-to-order items</strong>
        <br />
        Custom, altered, engraved, resized, personalized, and made-to-order items
        may require written approvals and may become non-cancellable once work or
        material commitment begins. Reasonable handmade and natural variation is
        expected. Project-specific terms and our{" "}
        <Link to="/custom-orders">Custom &amp; Made-to-Order Policy</Link> apply.
      </p>
      <p>
        <strong>Shipping, title, and risk</strong>
        <br />
        Processing and delivery dates are estimates unless expressly guaranteed.
        Shipping charges, tracking, customs, duties, delivery attempts, risk, and
        responsibility for an accurate address are described in the{" "}
        <Link to="/shipping">Shipping Policy</Link>. Nothing overrides mandatory
        rules about when risk passes to a consumer.
      </p>
      <p>
        <strong>Returns, defects, and repairs</strong>
        <br />
        Return eligibility, exclusions, fees, damaged items, and refund timing
        are governed by the <Link to="/returns">Refund Policy</Link>. Product
        defects and service options are described in the{" "}
        <Link to="/warranty-repairs">Warranty &amp; Repairs Policy</Link>. Rights that
        cannot be excluded by law continue to apply.
      </p>
      <p>
        <strong>Intellectual property</strong>
        <br />
        Site content is owned by Tuddlepetgoods, licensed to us, or otherwise
        used with legal permission. You receive no ownership right by using the
        site and may not commercially reproduce or exploit protected content
        without authorization. Third-party rights remain with their owners. See
        our <Link to="/intellectual-property">Intellectual Property Policy</Link>.
      </p>
      <p>
        <strong>Third-party services</strong>
        <br />
        Payment, delivery, hosting, or linked services may have separate terms.
        We are not responsible for unrelated third-party content or services we
        do not control, but this does not remove responsibility we have for our
        own obligations or selected service providers under mandatory law.
      </p>
      <p>
        <strong>Disclaimers</strong>
        <br />
        To the extent permitted by law, the site is provided on an “as available”
        basis and we do not guarantee uninterrupted access. Product-specific and
        general limitations are explained in the{" "}
        <Link to="/disclaimer">Website Disclaimer</Link>. We do not exclude any
        warranty or remedy that cannot legally be excluded.
      </p>
      <p>
        <strong>Limitation of liability</strong>
        <br />
        To the maximum extent permitted by law, we are not liable for indirect,
        incidental, special, or consequential loss that was not reasonably
        foreseeable when the contract was formed. For other claims connected
        with a purchase, our aggregate liability will not exceed the amount paid
        for the affected item. These limits do not apply to fraud, willful
        misconduct, death or personal injury caused by negligence, or any
        liability that law does not allow us to limit.
      </p>
      <p>
        <strong>Indemnity for misuse</strong>
        <br />
        To the extent permitted by law, you are responsible for loss reasonably
        arising from your unlawful misuse of the site, your infringement of
        another person&apos;s rights, or material you submit without permission.
        This does not make a consumer responsible for our own conduct.
      </p>
      <p>
        <strong>Governing law and disputes</strong>
        <br />
        These Terms are governed by the laws of Hong Kong, without excluding
        mandatory protections that apply where you live. Courts with lawful
        jurisdiction may hear a dispute. Before formal proceedings, we encourage
        use of our <Link to="/complaints">Complaints &amp; Dispute Resolution</Link>
        process, but it does not restrict urgent or statutory remedies.
      </p>
      <p>
        <strong>Changes, severability, and no waiver</strong>
        <br />
        We may update these Terms prospectively by posting a revised date. Terms
        in force when an order is accepted ordinarily govern that order. If one
        provision is unenforceable, it will be limited to the minimum necessary
        and the remainder continues. Delay in enforcing a right is not a waiver.
      </p>
      <p>
        <strong>Contact</strong>
        <br />
        Questions about these Terms can be sent to <SupportEmail />.
      </p>
    </PolicyPage>
  );
}

export default Terms;
